export enum LegacyIconName {
    CART = 'cart',
    TREATS = 'treats',
    PERSON = 'person',
    PIN = 'pin',
    TREATS_NEW = 'treats-new',
    TREATS_NEW_LG = 'treats-new-lg',
}
export type LegacyIconProps = {
    name: LegacyIconName;
    size: number;
    priority?: boolean;
    className?: string;
    focusable?: boolean;
};
